"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultimatchAddressModalCms = void 0;
var MultimatchAddressModalCms = /** @class */ (function () {
    function MultimatchAddressModalCms() {
        this.verifyAddressLabel = 'Verify your address';
        this.matchedAddressesDescriptionLabel = "We couldn't pinpoint your address, but we did find one or more close matches.\n                                Please select an option below.";
        this.noMatchedAddressDescriptionLabel = "We couldn't find a U.S. Postal Service\n     match for your address. Please select an option below.";
        this.useAddressLabel = 'Use the address as I&#39;ve entered it';
        this.correctAddressLabel = 'I need to correct my address and try again';
    }
    return MultimatchAddressModalCms;
}());
exports.MultimatchAddressModalCms = MultimatchAddressModalCms;
//# sourceMappingURL=MultimatchAddressModal.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/MultimatchAddressModal/MultimatchAddressModal.cms.js
// module id = 946
// module chunks = 8